import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import CustomBreadcrumbs from '../../components/custom-breadcrumbs';
import Iconify from '../../components/iconify';
import { useLocales } from '../../locales';
import { PATH_DASHBOARD } from '../../routes/paths';
import {
  defaultTabs,
  useClientListNavigatorContext,
} from './ClientListNavigatorContext';

export const Breadcrumbs = () => {
  const { currentTab } = useClientListNavigatorContext();
  const { translate } = useLocales();

  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      action={
        <Button
          component={RouterLink}
          startIcon={<Iconify icon="eva:plus-fill" />}
          to={PATH_DASHBOARD.client.new}
          variant="contained"
        >
          {`${translate('new')} ${translate('client')}`}
        </Button>
      }
      heading={`${translate('clients')}`}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        { href: PATH_DASHBOARD.client.root, name: `${translate('clients')}` },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
